import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useUserPost = (defaultId) => {
  const setUser = useCallback(({ id = defaultId, ...payload }) => {
    return new Request(`${API_BASE_URL}/api/v2/user/${id ? id + "/" : ""}`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setUser);
};

export default useUserPost;
